import React, { Component } from 'react';
import { connect } from 'react-redux';
import loadingGif from '../assets/loading.gif';
import './sellOffers.css';
import {
  makeGetRequest,
  makePostRequest
} from '../helpers/biztechAxiosRequest';
import SecureRoutesContainer from '../containers/SecureRoutesContainer';
import { Dialog } from '@avalara/skylab-react';
import _ from 'lodash';
import blueSearchIcon from '../assets/bluesearch.png';
import {
  DEFAULT_OFFER_CONFIG,
  DEFAULT_PRODUCT_CATALOG,
  getSellOfferEndpoint
} from '../constants/ApiEndpoints';
import Tooltip from '@material-ui/core/Tooltip';
import { Link } from 'react-router-dom';
import SearchIcon from '@material-ui/icons/Search';
import queryString from 'query-string';
import { withRouter } from '../containers/WithRouter';

function SearchBox(props) {
  return (
    <div className="SearchContainer">
      <div className="SearchBarArea">
        <div className="SearchBar">
          <input
            className="SearchBox"
            placeholder="Search Id ..."
            onKeyPress={props.handleKeyPress}
            value={props.customerAccountId}
            onChange={props.handleChange}
            type="text"
            name="customerAccountId"
            required
          />
          <img
            src={blueSearchIcon}
            alt="Search Icon"
            className="SearchButton"
            onClick={props.getCustomerAccount}
          />
        </div>
      </div>
    </div>
  );
}

function AccountDetail(props) {
  return (
    <s-box id="AccountDetailBox">
      <s-row>
        {!props.loading ? (
          <>
            <s-col span="5">
              <b>Customer Name </b>
            </s-col>
            <s-col span="5">{props.name || ''}</s-col>
            {props.customerAccountId !== '' && (
              <s-col span="2">
                <Tooltip title="Go to Search Page" placement="bottom">
                  <span id="SellOfferLink">
                    <Link
                      to={{
                        pathname: '/search',
                        search: `?query=${props.customerAccountId}`
                      }}
                    >
                      <SearchIcon style={{ color: '#059BD2', fontSize: 38 }} />
                    </Link>
                  </span>
                </Tooltip>
              </s-col>
            )}
          </>
        ) : (
          <>
            <s-col span="5">
              <b>Customer Name </b>
            </s-col>
            <s-col span="5">
              <img src={loadingGif} alt="Please wait" className="LoadingImg" />
            </s-col>
            {props.customerAccountId !== '' && (
              <s-col span="2">
                <Tooltip title="Go to Search Page" placement="bottom">
                  <span id="SellOfferLink">
                    <Link
                      to={{
                        pathname: '/search',
                        search: `?query=${props.customerAccountId}`
                      }}
                    >
                      <SearchIcon style={{ color: '#059BD2', fontSize: 38 }} />
                    </Link>
                  </span>
                </Tooltip>
              </s-col>
            )}
          </>
        )}
      </s-row>
    </s-box>
  );
}

function EnvironmentSelector(props) {
  return (
    <s-col span="6">
      <div className="text-left">
        <label>Choose Type Of Environment</label>
        <input
          type="checkbox"
          id="sandbox"
          name="sandbox"
          value="sandbox"
          className="environmentCheck"
          checked={props.showSandboxOffers}
          onChange={props.handleOnSandboxChange}
        />
        <label htmlFor="sandbox">Sandbox</label>
        <input
          type="checkbox"
          id="production"
          name="production"
          value="production"
          checked={props.showProductionOffers}
          className="environmentCheck"
          onChange={props.handleOnProductionChange}
        />
        <label htmlFor="production">Production</label>
      </div>
    </s-col>
  );
}

function SearchFilter(props) {
  return (
    <s-col span="6">
      <label htmlFor="offerSearchFilter">
        Filter Search
        {'  '}
        <s-icon name="search" role="img" aria-label="account alert"></s-icon>
      </label>
      <input
        type="text"
        id="offerSearchFilter"
        name="offerSearchFilter"
        value={props.offerSearchFilter}
        onChange={props.handleChange}
      />
    </s-col>
  );
}

function ErrorAlert(props) {
  return (
    <s-col span="6">
      {props.errorMsg ? (
        <s-alert status="error">
          <label>{props.errorMsg}</label>
        </s-alert>
      ) : props.successMsg ? (
        <s-alert status="success">
          <label>{props.successMsg}</label>
        </s-alert>
      ) : (
        ''
      )}
    </s-col>
  );
}

function OptionalParamSelector(props) {
  return (
    <div slot="body">
      <label>Optional Offer Params</label>
      <s-row>
        <s-col span="6">
          <input
            type="number"
            placeholder="Quantity"
            name="quantity"
            value={props.value}
            onChange={props.handleChange}
            className="margin-top-xs"
          />
        </s-col>
        <s-col span="6">
          <input
            type="number"
            placeholder="Tier Number"
            name="tierNumber"
            value={props.value}
            onChange={props.handleChange}
            className="margin-top-xs"
          />
        </s-col>
      </s-row>
      <s-row>
        <s-col span="6">
          <input
            type="text"
            placeholder="Connector Id"
            name="connectorId"
            value={props.value}
            onChange={props.handleChange}
            className="margin-top-xs"
            required={props.checkIsConnectorIdRequired(props.offerCode)}
            disabled={props.isAraMraOffer(props.offerCode)}
          />
        </s-col>
        <s-col span="6">
          <input
            type="text"
            placeholder="Payment Method"
            name="paymentMethodId"
            value={props.value}
            onChange={props.handleChange}
            className="margin-top-xs"
          />
        </s-col>
      </s-row>
      <s-row>
        <s-col span="6">
          <input
            type="text"
            placeholder="Avatax Id"
            name="avataxId"
            value={props.value}
            onChange={props.handleChange}
            className="margin-top-xs"
            required={props.isAraMraOffer(props.offerCode)}
          />
        </s-col>
        <s-col span="6">
          <input
            type="text"
            placeholder="Parent Avatax Id"
            name="parentAvataxId"
            value={props.value}
            onChange={props.handleChange}
            className="margin-top-xs"
            required={props.isAraMraOffer(props.offerCode)}
          />
        </s-col>
      </s-row>
    </div>
  );
}

function DialogHeader(props) {
  return (
    <div slot="header" id="dialog-title">
      <h1 className="text-center margin-all-xs">Sell Offer</h1>
      <b>
        <label className="text-left padding-top-5" id="customerName">
          {!props.loading ? (
            `Name: ${props.name}`
          ) : (
            <div>
              <span>Name : </span>
              <img src={loadingGif} alt="Please wait" className="LoadingImg" />
            </div>
          )}
        </label>
      </b>
      <b>
        <label className="text-left case-transformation" id="customerId">
          {!props.loading ? (
            `Id: ${props.customerIdReceivedFromGetCustomer}`
          ) : (
            <div>
              <span>Id : </span>
              <img src={loadingGif} alt="Please wait" className="LoadingImg" />
            </div>
          )}
        </label>
      </b>
      <hr />
      <label>Offer Code : {props.offerCode}</label>
    </div>
  );
}

function OfferDetailAccordion(props) {
  return (
    <div className="accordion-content">
      <s-table-container tabindex="0">
        <table id="offerTable">
          <thead>
            <tr>
              <th>Product</th>
              <th>CPQ Id</th>
              <th>Delivery System</th>
              <th>Entitlements</th>
            </tr>
          </thead>
          <tbody>
            {props.offer.lineitems &&
              props.offer.lineitems.map((lineItem, lineItemIndex) => {
                if (lineItem.entitlements) {
                  return lineItem.entitlements.map(
                    (entitlement, entitlementIndex) => (
                      <tr key={entitlementIndex}>
                        <td>{_.get(lineItem, 'productDescription', '')}</td>
                        <td>{_.get(lineItem, 'productRatePlanTierId', '')}</td>
                        <td>{_.get(entitlement, 'deliverySystem', '')}</td>
                        <td>
                          {entitlement &&
                            entitlement.service &&
                            entitlement.service.map((data, index) => (
                              <span key={index}>
                                {data.name}({data.id})
                                {index !== entitlement.service.length - 1
                                  ? ' ,'
                                  : ''}
                              </span>
                            ))}
                        </td>
                      </tr>
                    )
                  );
                } else {
                  return (
                    <tr key={lineItemIndex}>
                      <td>{_.get(lineItem, 'productDescription', '')}</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                  );
                }
              })}
          </tbody>
        </table>
      </s-table-container>
    </div>
  );
}

function UtilityButtons(props) {
  return (
    <s-col span="4" className="ButtonContainer">
      <button
        className="icon-trailing expandButton"
        onClick={props.expandAllHandler}
        small="true"
      >
        Expand All <s-icon name="arrow-down"></s-icon>
      </button>
      <button
        className="icon-trailing collapseButton"
        onClick={props.collapseAllHandler}
        small="true"
      >
        Collapse All <s-icon name="arrow-right"></s-icon>
      </button>
    </s-col>
  );
}

function OfferAccordionHeader(props) {
  return (
    <s-row collapse="xl">
      <s-col span="11">
        <div
          className="accordion-title"
          onClick={() => props.handleAccordion(props.index)}
        >
          <div className="justify-content-center align-items-center margin-top-xs margin-left-xs">
            {props.offer.offerId}
          </div>
          <div className="margin-right-sm">
            {props.accordion[props.index] ? (
              <s-icon name="arrow-right" class="primary"></s-icon>
            ) : (
              <s-icon name="arrow-down" class="primary"></s-icon>
            )}
          </div>
        </div>
      </s-col>
      <s-col span="1">
        <button
          className="dialogButton margin-right-sm"
          onClick={props.handleDialog}
          name={props.offer.offerId}
          small="true"
        >
          Sell
        </button>
      </s-col>
    </s-row>
  );
}

function DialogFooter(props) {
  return (
    <div slot="footer">
      <button
        className="secondary cancelButton small"
        onClick={props.handleDialog}
      >
        Cancel
      </button>
      <button
        className="primary float-right"
        type="submit"
        disabled={props.disabled}
      >
        Submit
      </button>
    </div>
  );
}

class SellOffers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      customerAccountId: '',
      customerIdReceivedFromGetCustomer: '',
      disabled: '',
      errorMsg: '',
      successMsg: '',
      loading: false,
      sellOfferLoading: false,
      offers: [],
      showSandboxOffers: true,
      showProductionOffers: true,
      offerSearchFilter: '',
      accordion: [],
      showDialog: false,
      offerCode: '',
      avataxId: '',
      parentAvataxId: '',
      ticketNumber: '',
      ticketPrefix: 'AUSS'
    };
  }

  getCustomerAccount = event => {
    if (event) event.preventDefault(); //As component mount will also call it
    this.setState({ loading: true });
    // const headers = { Authorization: `Bearer ${this.props.auth.token}` };
    const customerAccountId = this.state.customerAccountId;
    window.history.replaceState(
      null,
      'OPUS Sell Offer',
      `/#/sell-offers?id=${customerAccountId}`
    );
    this.setState({ errorMsg: '' });
    const getCustomerAccountEndpoint = `/customer/customer-accounts/${customerAccountId}`;
    makeGetRequest(getCustomerAccountEndpoint)
      .then(result => {
        this.setState({
          name: result.data.data.name,
          customerIdReceivedFromGetCustomer: result.data.data.id,
          disabled: 'false'
        });
      })
      .catch(error => {
        this.setState({
          name: '',
          customerIdReceivedFromGetCustomer: ''
        });
        if (error.response) {
          const res = error.response;
          if (res.status === 400) {
            if (res.data && res.data.message) {
              this.setError(res.data.message);
            } else {
              this.setError('Bad request. Please check your inputs.');
            }
          } else if (res.status === 500 || res.status === 502) {
            this.setError('Sorry, something went wrong!');
          }
        } else if (error.request) {
          // Request is formed but no response from server
          this.setError('Sorry, something went wrong!');
        } else {
          // Error in forming the request
          this.setError('Sorry, something went wrong!');
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  setError = error => {
    this.setState({ errorMsg: error });
  };

  sellOffer = event => {
    event.preventDefault();
    this.setState({ showDialog: false });
    this.setState({ sellOfferLoading: true });
    this.setState({ errorMsg: '' });
    this.setState({ successMsg: '' });
    // const headers = { Authorization: `Bearer ${this.props.auth.token}` };
    const offerEndpoint = getSellOfferEndpoint(this.state.offerCode);
    const payload = {
      ...(this.state.customerAccountId && {
        customerAccountId: this.state.customerAccountId
      }),
      offerCode: this.state.offerCode,
      ...(this.state.quantity && { quantity: parseInt(this.state.quantity) }),
      ...(this.state.tierNumber && {
        tierNumber: parseInt(this.state.tierNumber)
      }),
      ...(this.state.connectorId && { connectorId: this.state.connectorId }),
      ...(this.state.avataxId && { avataxId: this.state.avataxId }),
      ...(this.state.parentAvataxId && {
        parentAvataxId: this.state.parentAvataxId
      }),
      ...(this.state.paymentMethodId && {
        paymentMethodId: this.state.paymentMethodId
      })
    };

    const config = {
      headers: {
        correlationId:
          this.state.ticketPrefix +
          '_' +
          this.state.ticketNumber +
          '_' +
          Date.now()
      }
    };

    makePostRequest(offerEndpoint, payload, config)
      .then(result => {
        this.setState({ successMsg: 'Offer Data Save Successfully' });
      })
      .catch(error => {
        if (error.response) {
          const res = error.response;
          if (res.status === 400) {
            if (
              res.data &&
              res.data.errors &&
              res.data.errors[0] &&
              res.data.errors[0].message
            ) {
              this.setError(res.data.errors[0].message);
            } else if (res.data && res.data.message) {
              this.setError(
                `Bad request. Please check your inputs. :  ${res.data.message}`
              );
            } else {
              this.setError('Bad request. Please check your inputs.');
            }
          } else if (res.status === 500 || res.status === 502) {
            this.setError('Sorry, something went wrong!');
          }
        } else if (error.request) {
          // Request is formed but no response from server
          this.setError('Sorry, something went wrong!');
        } else {
          // Error in forming the request
          this.setError('Sorry, something went wrong!');
        }
      })
      .finally(() => {
        this.setState({
          sellOfferLoading: false,
          quantity: undefined,
          tierNumber: undefined,
          connectorId: undefined,
          paymentMethodId: undefined,
          avataxId: undefined,
          parentAvataxId: undefined
        });
      });
  };

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.getCustomerAccount();
    }
  };

  handleDialog = event => {
    event.preventDefault();
    if (!this.state.showDialog) {
      this.setState({
        offerCode: event.target.name,
        showDialog: !this.state.showDialog
      });
    } else {
      this.setState({ offerCode: '', showDialog: !this.state.showDialog });
    }
  };

  handleOnProductionChange = () => {
    this.setState({ showProductionOffers: !this.state.showProductionOffers });
  };

  handleOnSandboxChange = () => {
    this.setState({ showSandboxOffers: !this.state.showSandboxOffers });
  };

  handleAccordion = index => {
    const accordionState = this.state.accordion;
    accordionState[index] = !accordionState[index];
    this.setState({ accordion: accordionState });
  };

  getUniqueCatalogIds = offers => {
    const productRatePlanTierIds = [];
    for (const offer of offers) {
      for (const lineItem of offer.lineitems) {
        productRatePlanTierIds.push(lineItem.productRatePlanTierId);
      }
    }

    //Unique productRatePlanTierIds for Entitlement Request
    const uniqueProductRatePlanTierIds = [...new Set(productRatePlanTierIds)];

    //Creating Payload to be send to Product Catalog API
    const payload = { catalogid: uniqueProductRatePlanTierIds };
    return payload;
  };

  addEntitlementsToOffers = (offers, productCatalogData) => {
    //Creating a map for catalogId to their respective entitlements
    const hash = {};
    for (const data of productCatalogData) {
      hash[data.Id] = data.entitlements;
    }
    // Adding Entitlement Field to all offers
    offers.forEach(offer => {
      offer.lineitems.forEach((lineItem, ind) => {
        const lineItemWithSpecificFields = {
          productDescription: lineItem.productDescription,
          productRatePlanTierId: lineItem.productRatePlanTierId
        };
        if (hash[lineItem.productRatePlanTierId]) {
          lineItemWithSpecificFields['entitlements'] =
            hash[lineItem.productRatePlanTierId];
        }
        offer.lineitems[ind] = lineItemWithSpecificFields;
      });
    });
    return offers;
  };

  getOffersWithEntitlementsList = () => {
    // const headers = { Authorization: `Bearer ${this.props.auth.token}` };
    this.setState({ sellOfferLoading: true });

    //Getting Offers List using API Call
    const offerConfigEndpoint = DEFAULT_OFFER_CONFIG;
    makeGetRequest(offerConfigEndpoint)
      .then(result => {
        let offers = _.get(result, 'data.options', []);

        //Getting Entitlements for Catalog Ids - Using API
        const payload = this.getUniqueCatalogIds(offers);
        this.setState({ sellOfferLoading: true });
        makePostRequest(DEFAULT_PRODUCT_CATALOG, payload)
          .then(res => {
            const productCatalogData = _.get(
              res,
              'data.data.productCatalogData',
              null
            );
            if (productCatalogData) {
              offers = this.addEntitlementsToOffers(offers, productCatalogData);
              //Keeping only the displayed fields as we have to perform free text searching on it
              offers.forEach((offer, index) => {
                const offersWithSpecificFields = {
                  offerId: offer.offerId,
                  lineitems: offer.lineitems,
                  isConnectorIdRequired: offer.isConnectorIdRequired
                };
                offers[index] = offersWithSpecificFields;
              });
              //Only Unique Offer Code should presented irrespective of lineItems Data
              const uniqueOffers = [
                ...new Map(offers.map(item => [item['offerId'], item])).values()
              ];
              this.setState({
                offers: [...uniqueOffers],
                accordion: new Array(uniqueOffers.length).fill(false)
              });
            }
          })
          .catch(error => {
            if (error.response) {
              const res = error.response;
              if (res.status === 400) {
                this.setError('Bad request .');
              } else if (res.status === 500) {
                this.setError('Sorry, something went wrong!');
              } else {
                this.setError('Sorry, something went wrong!');
              }
            } else if (error.request) {
              this.setError('Sorry, something went wrong!');
            } else {
              this.setError('Sorry, something went wrong!');
            }
          })
          .finally(() => {
            this.setState({ sellOfferLoading: false });
          });
      })
      .catch(error => {
        if (error.response) {
          const res = error.response;
          if (res.status === 400) {
            this.setError('Bad request.');
          } else if (res.status === 500) {
            this.setError('Sorry, something went wrong!');
          } else {
            this.setError('Sorry, something went wrong!');
          }
        } else if (error.request) {
          this.setError('Sorry, something went wrong!');
        } else {
          this.setError('Sorry, something went wrong!');
        }
      });
  };

  isSandboxOffer = offer => {
    for (const lineItem of _.get(offer, 'lineitems', [])) {
      for (const entitlement of _.get(lineItem, 'entitlements', [])) {
        if (entitlement?.deliverySystem?.toLowerCase().includes('sandbox'))
          return true;
      }
    }
    return offer.offerId.includes('sandbox');
  };

  expandAllHandler = event => {
    event.preventDefault();
    const accordionState = this.state.accordion.map(acc => true);
    this.setState({ accordion: accordionState });
  };

  collapseAllHandler = event => {
    event.preventDefault();
    const accordionState = this.state.accordion.map(acc => false);
    this.setState({ accordion: accordionState });
  };

  handleUrlParameter = () => {
    const queryObj = queryString.parse(this.props.router.location.search);
    if (queryObj.id) {
      this.setState({ customerAccountId: queryObj.id }, () => {
        this.getCustomerAccount();
      });
    }
  };

  checkIsConnectorIdRequired = offerCode => {
    for (const offer of this.state.offers) {
      if (offer.offerId === offerCode) return offer.isConnectorIdRequired;
    }
    return false;
  };

  isAraMraOffer = offerCode => {
    return ['arapooledusagesource', 'aramanagedpooledusagesource'].includes(
      offerCode
    );
  };

  checkDisableStatus = offerCode => {
    if (this.isAraMraOffer(offerCode)) {
      return !(
        this.state.avataxId &&
        this.state.parentAvataxId &&
        this.state.ticketNumber
      );
    } else {
      return !(this.state.disabled !== '' && this.state.ticketNumber);
    }
  };

  componentDidMount() {
    this.handleUrlParameter();
    this.getOffersWithEntitlementsList();
  }

  filterSearch = (obj, query) => {
    for (const key in obj) {
      const value = obj[key];
      if (typeof value === 'object') {
        if (this.filterSearch(value, query)) return obj;
      } else if (
        typeof value === 'string' &&
        value.toLowerCase().includes(query)
      ) {
        return obj;
      }
    }
  };

  render() {
    const { offerSearchFilter, offers } = this.state;
    const lowercasedFilter = offerSearchFilter.toLowerCase();
    const filteredData = offers.filter(item => {
      return this.filterSearch(item, lowercasedFilter);
    });

    if (this.state.sellOfferLoading) {
      return (
        <div>
          {' '}
          <br />
          <br /> <br /> <img src={loadingGif} alt="Please wait" />{' '}
          <h1>processing ...</h1>{' '}
        </div>
      );
    }

    return (
      <SecureRoutesContainer page="sell-offers">
        <div>
          <SearchBox
            handleKeyPress={this.handleKeyPress}
            customerAccountId={this.state.customerAccountId}
            handleChange={this.handleChange}
            getCustomerAccount={this.getCustomerAccount}
          />
          <h1>Sell New Offer</h1>
          <s-row collapse="lg">
            <s-col span="2"></s-col>
            <s-col span="8">
              <AccountDetail
                loading={this.state.loading}
                name={this.state.name}
                customerAccountId={this.state.customerAccountId}
              />
              <fieldset className="padding-20">
                <form
                  className="text-left"
                  aria-label="get account details"
                  onSubmit={this.sellOffer}
                >
                  <s-row>
                    <EnvironmentSelector
                      showSandboxOffers={this.state.showSandboxOffers}
                      handleOnSandboxChange={this.handleOnSandboxChange}
                      showProductionOffers={this.state.showProductionOffers}
                      handleOnProductionChange={this.handleOnProductionChange}
                    />
                    <SearchFilter
                      offerSearchFilter={this.state.offerSearchFilter}
                      handleChange={this.handleChange}
                    />
                  </s-row>
                  <br />
                  <s-row>
                    <ErrorAlert
                      errorMsg={this.state.errorMsg}
                      successMsg={this.state.successMsg}
                    />
                    <s-col span="6"></s-col>
                  </s-row>
                  {this.state.offerCode !== '' && (
                    <Dialog open={this.state.showDialog} id="offerDialog">
                      <DialogHeader
                        loading={this.state.loading}
                        name={this.state.name}
                        customerIdReceivedFromGetCustomer={
                          this.state.customerIdReceivedFromGetCustomer
                        }
                        offerCode={this.state.offerCode}
                      />
                      <hr />
                      <label>Enter Ticket Details</label>
                      <s-row>
                        <s-col span="6">
                          <select
                            name="ticketPrefix"
                            value={this.state.ticketPrefix}
                            onChange={this.handleChange}
                          >
                            <option value="AUSS">AUSS</option>
                            <option value="OPUS">OPUS</option>
                            <option value="PLAUNCH">PLAUNCH</option>
                          </select>
                        </s-col>
                        <s-col span="6">
                          <input
                            type="number"
                            placeholder="Ticket Number"
                            name="ticketNumber"
                            value={this.state.ticketNumber}
                            onChange={this.handleChange}
                            required
                          />
                        </s-col>
                      </s-row>
                      <hr />
                      <OptionalParamSelector
                        value={this.state.value}
                        handleChange={this.handleChange}
                        checkIsConnectorIdRequired={
                          this.checkIsConnectorIdRequired
                        }
                        offerCode={this.state.offerCode}
                        isAraMraOffer={this.isAraMraOffer}
                      />
                      <br />
                      <DialogFooter
                        handleDialog={this.handleDialog}
                        disabled={this.checkDisableStatus(this.state.offerCode)}
                      />
                    </Dialog>
                  )}
                  <br />
                  <div className="margin-bottom-sm">
                    <s-row>
                      <s-col span="8">
                        <label>Select Offer</label>
                      </s-col>
                      <UtilityButtons
                        expandAllHandler={this.expandAllHandler}
                        collapseAllHandler={this.collapseAllHandler}
                      />
                    </s-row>
                  </div>
                  <br />
                  <div id="main">
                    <s-row>
                      {filteredData.length === 0 &&
                        this.state.offers.length !== 0 && (
                          <div className="margin-top-md">
                            <label>
                              No Offer Found With Filter Search key{' '}
                              <b>{this.state.offerSearchFilter}</b>
                            </label>
                          </div>
                        )}
                      {filteredData.map((offer, index) => {
                        if (
                          (this.state.showSandboxOffers &&
                            this.isSandboxOffer(offer)) ||
                          (this.state.showProductionOffers &&
                            !this.isSandboxOffer(offer))
                        ) {
                          return (
                            <s-col key={offer.offerId}>
                              <div className="accordion-item margin-bottom-xs">
                                <OfferAccordionHeader
                                  handleAccordion={this.handleAccordion}
                                  accordion={this.state.accordion}
                                  handleDialog={this.handleDialog}
                                  offer={offer}
                                  index={index}
                                />
                                {this.state.accordion[index] && (
                                  <OfferDetailAccordion
                                    key={offer.offerId}
                                    offer={offer}
                                  />
                                )}
                              </div>
                            </s-col>
                          );
                        } else {
                          return <></>;
                        }
                      })}{' '}
                    </s-row>
                  </div>
                  {this.state.offers.length === 0 && (
                    <div className="margin-top-md">
                      <label>
                        <b>Sorry No Offers Found !!</b>
                      </label>
                    </div>
                  )}
                </form>
              </fieldset>
            </s-col>
          </s-row>
        </div>
      </SecureRoutesContainer>
    );
  }
}

export default connect(({ auth }) => ({ auth }))(withRouter(SellOffers));
